import { cssVar } from '@chakra-ui/react';

const $bg = cssVar('tooltip-bg');
const $fg = cssVar('tooltip-fg');
const $arrowBg = cssVar('popper-arrow-bg');

export const Tooltip = {
  baseStyle: {
    bg: $bg.reference,
    color: $fg.reference,
    [$bg.variable]: 'black',
    [$fg.variable]: 'colors.whiteAlpha.900',
    [$arrowBg.variable]: $bg.reference,
    px: '2',
    py: '1',
    borderRadius: 'md',
    fontWeight: 'medium',
    fontSize: 'sm',
    boxShadow: 'md',
    maxW: 'xs',
    zIndex: 'tooltip',
  },
};
